const forbiddenPaths = [
	'isLogin',
	'login',
	'statistics/list',
	'statistics/rate-average',
	'graph',
	'invoice/total',
	'invoice/filters',
];
export const getExistingPath = function(url) {
	return forbiddenPaths.some(item => url.includes(item));
};
